import React, { useMemo } from "react";
import { TransformedProduct } from "../../../types/productApiTypes";
import { resolveCardImages } from "../../../helpers/productApiHelpers/imageResolver";
import { ImageSourceType } from "../../../../../../types/globalTypes";

interface CardImageProps {
  product: TransformedProduct;
}

/**
 * Renders the main image and hover image for the product card using the resolution engine.
 */
const CardImage: React.FC<CardImageProps> = ({ product }) => {
  // Read config with safe fallbacks
  const config = window.commonVariables?.uiSettings?.imageResolution
    ?.productCard || {
    primary: ["VARIATION_MAIN", "PARENT_MAIN"] as ImageSourceType[],
    hover: ["PARENT_GALLERY", "PARENT_MAIN"] as ImageSourceType[],
  };

  const { primaryImage: mainImage, hoverImage } = useMemo(
    () => resolveCardImages(product, config),
    [product, config],
  );

  return (
    <a href={product.permalink} aria-label={`View details for ${product.name}`}>
      {mainImage ? (
        <img
          src={mainImage.thumbnail}
          data-srcset={mainImage.srcset}
          data-sizes="auto"
          alt={mainImage.alt || product.name}
          className="product-card__image product-card__image--primary lazyload"
        />
      ) : (
        <div className="product-card__image-placeholder"></div>
      )}
      {hoverImage && (
        <img
          src={hoverImage.thumbnail}
          data-srcset={hoverImage.srcset}
          data-sizes="auto"
          alt={hoverImage.alt || product.name}
          className="product-card__image product-card__image--secondary lazyload"
          aria-hidden="true"
        />
      )}
    </a>
  );
};

export default CardImage;
